<div
  #modal
  class="flex flex-col flex-auto bg-white"
  [matDialogFullscreen]="fullscreen"
>
  <div
    #titleContainer
    mat-dialog-title
    class="flex items-center justify-between border-b border-inherit py-2"
    [class]="innerDividingLines ? 'px-0 mx-4' : 'px-4'"
    [class.hidden]="!hasTitle"
    [class.py-0]="['sm'].includes(size)"
    [class.px-2]="['sm'].includes(size)"
    [class.p-2]="['md'].includes(size)"
    [class.p-4]="['lg', 'xl'].includes(size)"
  >
    <div class="svc-dialog-title flex-auto flex gap-2 text-xl font-bold text-default">
      <ng-content select="[svc-dialog-title-icon]"></ng-content>
      <ng-content select="[svc-dialog-title]"></ng-content>
    </div>

    @if (!hideCloseButton) {
      <button
        svc-btn-icon
        color="text"
        class="-mr-2 print:hidden rounded-full"
        icon="heroicons_solid:x-mark"
        (click)="closeDialog()"
      ></button>
    }
  </div>

  <div *screenSizes="let size" class="flex flex-col flex-auto" [class.overflow-auto]="scrollInsideContent" [style.maxHeight]="size.isXS && scrollInsideContent ? ('calc(100vh - ' +  ((dialogTitleContainer?.nativeElement?.clientHeight ?? 0) + (dialogActions?.nativeElement?.parentElement?.clientHeight ?? 0) + (defaultActions?.nativeElement?.clientHeight ?? 0)) + 'px)') : null">
    <ng-content select="[svc-dialog-content]" mat-dialog-content></ng-content>
  </div>

  <div
    mat-dialog-actions
    align="end"
    class="border-t border-inherit"
    *ngIf="hasActions && manualActions"
    [class]="innerDividingLines ? 'px-0 mx-4' : 'px-4'"
  >
    <ng-content select="[svc-dialog-actions]"></ng-content>
  </div>

  <div
    #defaultActions
    mat-dialog-actions
    align="end"
    class="border-t border-inherit"
    *ngIf="hasActions && !manualActions && dialogStyle"
    [class]="innerDividingLines ? 'px-0 mx-4' : 'px-4'"
  >
    @if (dialogStyle === 'form') {
      <div class="flex flex-row gap-2">
        <button
          svc-outlined-btn
          type="button"
          id="svc-dialog-button-cancel"
          [disabled]="disabledConfirm"
          (click)="closeDialog()"
          [disabled]="disabledConfirm"
        >
          {{ textCancel ?? ('Cancelar' | transloco) }}
        </button>

        <button
          svc-filled-btn
          type="button"
          id="svc-dialog-button-save"
          [disabled]="disabledConfirm"
          (click)="confirmed.emit()"
        >
          {{ textConfirm ?? ('Salvar' | transloco) }}
        </button>
      </div>
    }

    @if (dialogStyle === 'close') {
      <button
        svc-filled-btn
        type="button"
        id="svc-dialog-button-close"
        [disabled]="disabledConfirm"
        (click)="closeDialog()"
        [disabled]="disabledConfirm"
      >
        {{ textCancel ?? ('Fechar' | transloco) }}
      </button>
    }
  </div>
</div>
